module.exports = __webpack_public_path__ + "img/viggle.ee64b3dc.png";